module.exports = __webpack_public_path__ + "img/6_144.e7c92c05.png";